import React from 'react';

// fieldType определяет что рисовать: "football", "pool", или "hockey"
export default function PlayerField({ fieldType, positions = [] }) {

    if (fieldType === 'football') {
        return (
            <div className="field-container football-field">
                <div className="field-center-circle" />
                <div className="field-center-line" />
                <div className="field-goal top" />
                <div className="field-goal bottom" />
                {positions.map((pos, i) => (
                    <div key={i} className="player-dot"
                        style={{ left: `${pos.x}%`, top: `${pos.y}%`, background: pos.color || '#3498db' }}
                        title={pos.playerName}>
                        <span>{pos.playerName?.charAt(0)}</span>
                    </div>
                ))}
            </div>
        );
    }

    if (fieldType === 'pool') {
        return (
            <div className="field-container pool-field">
                {Array.from({ length: 8 }, (_, i) => (
                    <div key={i} className={`pool-lane ${i % 2 === 0 ? 'lane-light' : 'lane-dark'}`}>
                        <span className="lane-number">{i + 1}</span>
                        {positions.filter(p => p.laneNumber === i + 1).map((pos, j) => (
                            <div key={j} className="swimmer-dot"
                                style={{ left: `${pos.x}%`, background: pos.color || '#1a5fa0' }}
                                title={pos.playerName}>
                                {pos.playerName?.charAt(0)}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    if (fieldType === 'hockey') {
        return (
            <div className="field-container hockey-field">
                <div className="hockey-center-circle" />
                <div className="hockey-blue-line top" />
                <div className="hockey-blue-line bottom" />
                <div className="hockey-red-line" />
                <div className="hockey-goal top" />
                <div className="hockey-goal bottom" />
                {positions.map((pos, i) => (
                    <div key={i} className="player-dot"
                        style={{ left: `${pos.x}%`, top: `${pos.y}%`, background: pos.color || '#2c3e8f' }}
                        title={pos.playerName}>
                        <span>{pos.playerName?.charAt(0)}</span>
                    </div>
                ))}
            </div>
        );
    }

    return null;
}